/**
 * User Roles and Permission Constants
 */
export const NETWORK_MANAGEMENT_ALLOWED_ROLES = [
  'General_and_Network_Management',
  'UHCI_Admin',
  'UHCI_Project',
  'GeneralPlus_ProviderExperienceMeasurement'
];

/**
 * Menu Key Constants
 */
export const MENU_KEYS = {
  NETWORK_MANAGEMENT: 'networkmanagement'
};

/**
 * Navigation Item Name Constants
 */
export const NAV_ITEM_NAMES = {
  IMPACT: 'IMPACT'
};

export const state = {
    "affTaxId": [
        {
            "Tin": "All",
            "Tinname": "All"
        }
    ],
    "vbcTaxId": [
        {
            "Tin": "All",
            "Tinname": "All"
        }
    ],
    "exemptionTaxId": [
        {
            "Tin": "All",
            "Tinname": "All"
        }
    ],
    "reconGlobal": {},
    "Tins": [],
    "selectedCorporateTin": {
        "name": "BRUNSWICK COMMUNITY HOSPITAL",
        "value": "204278130"
    },
    "legendGlobal": {},
    "extendedCorporateTinSelected": {
        "TINNAME": "All",
        "Tin": "All Selected TINs",
        "Tinname": "All",
        "isEnabled": false,
        "isSelected": false
    },
    "journeyExtendedTinSelected": {
        "taxId": [
            {
                "TINNAME": "EAST COOPER MEDICAL CENTER",
                "Tinname": "EAST COOPER MEDICAL CENTER",
                "Tin": "934555562"
            },
            {
                "TINNAME": "MEDICAL PARK HOSPITAL",
                "Tinname": "MEDICAL PARK HOSPITAL",
                "Tin": "561340424"
            },
            {
                "TINNAME": "BRUNSWICK COMMUNITY HOSPITAL",
                "Tinname": "BRUNSWICK COMMUNITY HOSPITAL",
                "Tin": "204278130"
            },
            {
                "TINNAME": "NOVANT HEALTH KERNERSVILLE OP SURG CTR",
                "Tinname": "NOVANT HEALTH KERNERSVILLE OP SURG CTR",
                "Tin": "821651821"
            },
            {
                "TINNAME": "NOVANT HEALTH BALLANTYNE MEDICAL CENTER",
                "Tinname": "NOVANT HEALTH BALLANTYNE MEDICAL CENTER",
                "Tin": "863305323"
            },
            {
                "TINNAME": "NOVANT MEDICAL GROUP",
                "Tinname": "NOVANT MEDICAL GROUP",
                "Tin": "581728803"
            },
            {
                "TINNAME": "NMG AFFILIATE PRACTICE I",
                "Tinname": "NMG AFFILIATE PRACTICE I",
                "Tin": "562084786"
            },
            {
                "TINNAME": "NOVANT HEALTH PLASTIC & RECONSTRUCTIVE S",
                "Tinname": "NOVANT HEALTH PLASTIC & RECONSTRUCTIVE S",
                "Tin": "994886012"
            },
            {
                "TINNAME": "NOVANT HEALTH ROWAN MEDICAL CENTER LLC",
                "Tinname": "NOVANT HEALTH ROWAN MEDICAL CENTER LLC",
                "Tin": "560547479"
            },
            {
                "TINNAME": "NOVANT HEALTH CLEMMONS OUTPATIENT SURGER",
                "Tinname": "NOVANT HEALTH CLEMMONS OUTPATIENT SURGER",
                "Tin": "825250651"
            },
            {
                "TINNAME": "HILTON HEAD MEDICAL CENTER",
                "Tinname": "HILTON HEAD MEDICAL CENTER",
                "Tin": "934604680"
            },
            {
                "TINNAME": "PPCP ENDOSCOPY",
                "Tinname": "PPCP ENDOSCOPY",
                "Tin": "863706197"
            },
            {
                "TINNAME": "PRESBYTERIAN HOSPITAL",
                "Tinname": "PRESBYTERIAN HOSPITAL",
                "Tin": "560554230"
            },
            {
                "TINNAME": "NH-CL CLINICS",
                "Tinname": "NH-CL CLINICS",
                "Tin": "844067176"
            },
            {
                "TINNAME": "SOUTHEASTERN SPINE INSTITUTE",
                "Tinname": "SOUTHEASTERN SPINE INSTITUTE",
                "Tin": "208037589"
            },
            {
                "TINNAME": "PENDER MEMORIAL HOSPITAL",
                "Tinname": "PENDER MEMORIAL HOSPITAL",
                "Tin": "560653348"
            },
            {
                "TINNAME": "NOVANT HEALTH WILMINGTON ENDOSCOPY CENTE",
                "Tinname": "NOVANT HEALTH WILMINGTON ENDOSCOPY CENTE",
                "Tin": "862943847"
            },
            {
                "TINNAME": "NOVANT HEALTH NEW HANOVER REGIONAL MEDIC",
                "Tinname": "NOVANT HEALTH NEW HANOVER REGIONAL MEDIC",
                "Tin": "853777599"
            },
            {
                "TINNAME": "EAST COOPER PHYSICIAN GROUP",
                "Tinname": "EAST COOPER PHYSICIAN GROUP",
                "Tin": "934624425"
            },
            {
                "TINNAME": "NOVANT HEALTH MEDICAL GROUP COASTAL REGI",
                "Tinname": "NOVANT HEALTH MEDICAL GROUP COASTAL REGI",
                "Tin": "861441258"
            },
            {
                "TINNAME": "MOUNT PLEASANT OUTPATIENT SURGERY CENTER",
                "Tinname": "MOUNT PLEASANT OUTPATIENT SURGERY CENTER",
                "Tin": "883714959"
            },
            {
                "TINNAME": "PRESBYTERIAN MEDICAL CARE CORP",
                "Tinname": "PRESBYTERIAN MEDICAL CARE CORP",
                "Tin": "561376368"
            },
            {
                "TINNAME": "CAROLINA MEDICORP ENTERPRISES LLC",
                "Tinname": "CAROLINA MEDICORP ENTERPRISES LLC",
                "Tin": "581466368"
            },
            {
                "TINNAME": "NOVANT HEALTH BRUNSWICK ENDOSCOPY",
                "Tinname": "NOVANT HEALTH BRUNSWICK ENDOSCOPY",
                "Tin": "820831203"
            },
            {
                "TINNAME": "FORSYTH MEDICAL GROUP",
                "Tinname": "FORSYTH MEDICAL GROUP",
                "Tin": "311725913"
            },
            {
                "TINNAME": "FOUNDATION HEALTH SYSTEMS LLC",
                "Tinname": "FOUNDATION HEALTH SYSTEMS LLC",
                "Tin": "561373175"
            },
            {
                "TINNAME": "",
                "Tinname": "",
                "Tin": "934646081"
            },
            {
                "TINNAME": "NHRMC HOME CARE",
                "Tinname": "NHRMC HOME CARE",
                "Tin": "352379154"
            },
            {
                "TINNAME": "NOVANT HEALTH URGENT CARES",
                "Tinname": "NOVANT HEALTH URGENT CARES",
                "Tin": "994277174"
            },
            {
                "TINNAME": "NOVANT HEALTH THOMASVILLE MEDICAL CENTER",
                "Tinname": "NOVANT HEALTH THOMASVILLE MEDICAL CENTER",
                "Tin": "560636250"
            },
            {
                "TINNAME": "NOVANT HEALTH MINT HILL MED CENTER",
                "Tinname": "NOVANT HEALTH MINT HILL MED CENTER",
                "Tin": "260599536"
            },
            {
                "TINNAME": "FORSYTH MEMORIAL HOSPITAL",
                "Tinname": "FORSYTH MEMORIAL HOSPITAL",
                "Tin": "560928089"
            },
            {
                "TINNAME": "NOVANT HEALTH TRIANGLE MEDICAL GROUP",
                "Tinname": "NOVANT HEALTH TRIANGLE MEDICAL GROUP",
                "Tin": "994837166"
            },
            {
                "TINNAME": "NH DIGITAL HEALTH SERVICES",
                "Tinname": "NH DIGITAL HEALTH SERVICES",
                "Tin": "843930503"
            },
            {
                "TINNAME": "TRIAD IMAGING",
                "Tinname": "TRIAD IMAGING",
                "Tin": "352674089"
            },
            {
                "TINNAME": "SOUTHEASTERN SPINE INSTITUTE",
                "Tinname": "SOUTHEASTERN SPINE INSTITUTE",
                "Tin": "994442855"
            },
            {
                "TINNAME": "SOUTH CAROLINA COASTAL MEDICAL CENTER",
                "Tinname": "SOUTH CAROLINA COASTAL MEDICAL CENTER",
                "Tin": "934580630"
            }
        ],
        "affTaxId": [],
        "priorAuthTaxId": [],
        "smartEditTaxId": [],
        "vbcTaxId": [],
        "exemptionTaxId": []
    },
    "journeyExtendedTinFilterSelected": {
        "taxId": [
            {
                "TINNAME": "All",
                "Tin": "All",
                "Tinname": "All",
                "isEnabled": false,
                "isSelected": false
            }
        ],
        "affTaxId": [
            {
                "TINNAME": "All",
                "Tin": "All",
                "Tinname": "All",
                "isEnabled": false,
                "isSelected": false
            }
        ],
        "priorAuthTaxId": [
            {
                "TINNAME": "All",
                "Tin": "All",
                "Tinname": "All",
                "isEnabled": false,
                "isSelected": false
            }
        ],
        "smartEditTaxId": [
            {
                "TINNAME": "All",
                "Tin": "All",
                "Tinname": "All",
                "isEnabled": false,
                "isSelected": false
            }
        ],
        "vbcTaxId": [
            {
                "TINNAME": "All",
                "Tin": "All",
                "Tinname": "All",
                "isEnabled": false,
                "isSelected": false
            }
        ],
        "exemptionTaxId": [
            {
                "TINNAME": "All",
                "Tin": "All",
                "Tinname": "All",
                "isEnabled": false,
                "isSelected": false
            }
        ]
    },
    "hcoExtendedCorporateTinSelected": [],
    "paymentClaimYeild": "All",
    "currentPage": "ScoreCard",
    "currentUrl": "/MyInsights",
    "timePeriod": "Last12Months",
    "timePeriodVBC": "2025",
    "taxId": [
        {
            "Tin": "All",
            "Tinname": "All"
        }
    ],
    "taxIdSmartEdit": [
        {
            "Tin": "All",
            "Tinname": "All"
        }
    ],
    "lineOfBusiness": "All",
    "adjudicationType": "All",
    "region": "NATIONAL",
    "states": [],
    "market": "",
    "mapping": "PROVIDER",
    "edcLineOfBusiness": {
        "order": "1",
        "value": "Commercial",
        "name": "COMMERCIAL"
    },
    "dplineOfBusiness": "All",
    "productType": [
        {
            "ClaimProducts": [
                "All"
            ],
            "ClaimSystem": "All",
            "Lob": [
                "All"
            ],
            "ProductName": "All"
        }
    ],
    "reconsiderationValues": "All",
    "adjustmentValues": "All",
    "commercial": "All",
    "channel": "All",
    "serviceSetting": "All",
    "providerSetting": "Requesting Provider",
    "serviceCategory": "All",
    "priorAuthType": "All",
    "trendMetric": "Reimbursements",
    "trendDate": "2025-12-22T06:28:18.497Z",
    "claimsFilter": "All",
    "ClaimProducts": [],
    "appealsFilter": "Received Date",
    "viewClaimsByFilter": "DOS",
    "platformType": [
        {
            "name": "All",
            "value": "All",
            "check": true
        }
    ],
    "topFilterTimePeriod": {
        "FilterText": "All",
        "StartDate": "All",
        "EndDate": "All",
        "Default": "All"
    },
    "topFilterTin": {
        "Tin": "All",
        "TinName": "All"
    },
    "topFilterNpi": {
        "Npi": "All",
        "NpiName": "All"
    },
    "topFilterSpeciality": {
        "Speciality": "All"
    },
    "topFilterLob": {
        "Lob": "All"
    },
    "priorAuthFilters": {
        "timePeriod": "Last12Months",
        "timePeriodText": "",
        "taxId": [
            {
                "Tin": "All",
                "Tinname": "All"
            }
        ],
        "lineOfBusiness": "All",
        "providerSetting": "Requesting Provider",
        "channel": "All",
        "serviceSetting": "All",
        "serviceCategory": "All",
        "npi": {
            "Value": "All",
            "Name": "All"
        },
        "specialty": {
            "Value": "All",
            "Name": "All"
        }
    },
    "gapsInCareFilters": {
        "TimePeriod": {
            "title": "Nov YTD (01/01/2025-11/30/2025)",
            "value": "01/01/2025-11/30/2025"
        },
        "Lob": {
            "pages": [
                "GAPS_IN_CARE"
            ],
            "title": "All",
            "value": "All"
        },
        "Tin": {
            "Tin": "All",
            "Tinname": "All"
        },
        "Npi": {
            "Npi": "All",
            "NpiName": "All"
        }
    },
    "PACaseSubmissionFilters": {
        "TimePeriod": {
            "title": "Nov YTD (01/01/2025-11/30/2025)",
            "value": "01/01/2025-11/30/2025"
        },
        "Lob": {
            "pages": [
                "PA_CASE_SUBMISSION"
            ],
            "title": "All",
            "value": "All"
        },
        "Tin": {
            "Tin": "All",
            "Tinname": "All"
        },
        "Npi": {
            "Npi": "All",
            "NpiName": "All"
        }
    },
    "glossaryOpen": false,
    "tileIds": [],
    "selectedPoca": {
        "timePeriod": {
            "title": "Nov YTD (01/01/2025-11/30/2025)",
            "value": "01/01/2025-11/30/2025",
            "POCAViewKeys": [
                "EMR",
                "ELINK",
                "SYSTEM_PAAN"
            ]
        },
        "taxId": {
            "Tin": "All",
            "Tinname": "All"
        },
        "lob": "All",
        "channel": "EMR",
        "npi": {
            "Npi": "All",
            "NpiName": "All"
        }
    },
    "multiSelectData": {
        "tabIndex": 0,
        "groupName": ""
    },
    "affordabilityPrograms": {},
    "ADMFilters": {
        "Lob": {},
        "State": {}
    },
    "LOCFilters": {
        "Lob": {},
        "View": {}
    },
    "startDate": "",
    "endDate": "",
    "selectedState": {
        "name": "",
        "value": ""
    },
    "tinsInfo": [],
    "priorAuth": {
        "TaxId": {
            "title": "All",
            "value": "All"
        },
        "Npi": {
            "title": "All",
            "value": ""
        },
        "Specialty": {
            "title": "All",
            "value": ""
        },
        "Timeperiod": "Last12Months",
        "TimeperiodText": ""
    }
}